import configDB from '../../../data/customizer/config'
const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
const secondary = localStorage.getItem('secondary_color') || configDB.data.color.secondary_color;








export const barChart = {
    options : {
        
    legend: {
        show: false
    },
    chart: {
          type: 'bar',
          height: 150
        },
    plotOptions: {
        bar: {
            radius: 10,
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
        }
    },
    dataLabels: {
        enabled: false
    },
    stroke: {
        show: true,
        colors: ['transparent'],
        curve: 'smooth',
        lineCap: 'butt'
    },
    grid: {
        show: false,
        padding: {
            left: 0,
            right: 0
        }
    },
    xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
        labels: {
            show: false,
        },
    },
    fill: {
        colors:["lightgreen", primary, "gray"],
        type: 'gradient',
        gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.1,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.9,
            stops: [0, 100]
        }
    },

    tooltip: {
        y: {
            formatter: function (val) {
                return "Rs " + val 
            }
        }
    }
    },
    series: [{
        name: 'Net Profit',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 61, 69, 63]
    }, {
        name: 'Revenue',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 106, 92, 114]
    }, {
        name: 'Free Cash Flow',
        data: [35, 41, 36, 26, 45, 48, 52, 53, 41, 60, 66, 70]
    }],
    }






















